document.addEventListener("DOMContentLoaded", () => {
  
    // Checks if a Customer started a Checkout but was redirected due to not being logged in
    const isFromCheckout = () => {

    // Check for a 'checkout_url' parameter in the current URL
    const urlParams = new URLSearchParams(window.location.search);
    const checkoutUrlParam = urlParams.get("checkout_url");
    const isFromUrlParam =
      checkoutUrlParam && checkoutUrlParam.includes("/checkouts/");

    // Check the referring page's URL
    const referrer = document.referrer;
    const isFromReferrer = referrer && referrer.includes("/checkout");

    return isFromUrlParam || isFromReferrer;
  };

  if (isFromCheckout()) {
    // Handle login form
    const loginForm = document.querySelector("form#customer_login");
    if (loginForm) {
      const redirectField = document.createElement("input");
      redirectField.type = "hidden";
      redirectField.name = "return_to";
      redirectField.value = "/cart";
      loginForm.appendChild(redirectField);
      loginForm.querySelector('[name="checkout_url"]')?.remove();
    }

    const registerForm = document.querySelector("form#create_customer");
    if (registerForm) {
      /** Removes hidden input field to prevent redirect to Checkout */
      registerForm.querySelector('[name="checkout_url"]')?.remove();
      registerForm.addEventListener("submit", (event) => {
        event.preventDefault();
    
        sessionStorage.setItem("trigger_redirect", "/cart");
        console.log("Item set. User will be redirected to cart after registration.");
    
        registerForm.submit();
      });
    }
  }
});

(() => {
  const triggerRedirect = !!sessionStorage.getItem("trigger_redirect");

  if (!triggerRedirect) return;

  const redirectTo = sessionStorage.getItem("trigger_redirect");
  sessionStorage.removeItem("trigger_redirect");
  location.href = redirectTo;
})();